module.exports = __webpack_public_path__ + "static/img/pg.b916239.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pg.png
// module id = BXBC
// module chunks = 1